import React, { Component } from 'react';

import SelectClubKNVB from './SelectClubKNVB'
import SelectClubSL from './SelectClubSL'

import './SelectClub.css';


class SelectClub extends Component {
  constructor(props) {
    super(props);
    this.unionid = this.props.match.params.unionid;
  }

  render() {
    if (this.unionid === 'KNVB') {
      return <SelectClubKNVB unionid={this.unionid} {...this.props}  />
    } else {
      return <SelectClubSL unionid={this.unionid} {...this.props} />
    }
  }
}

export default SelectClub



// WEBPACK FOOTER //
// ./src/club/SelectClub.jsx